import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from 'js-cookie';

const BaseUrl = process.env.REACT_APP_API_URL;

const loginData = Cookies.get("loginData");
const PersonData = loginData ? JSON.parse(loginData) : null;


// 👉 1. Fetch All Projects
export const fetchAllProjects = createAsyncThunk(
  "project/fetchAllProjects",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/TablemangeController/show_project`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 👉 2. Fetch All Types (by Project ID)
export const fetchAllTypes = createAsyncThunk(
  "project/fetchAllTypes",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/TablemangeController/show_Type/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 👉 3. Fetch All Modules (by Type ID)
export const fetchAllModules = createAsyncThunk(
  "project/fetchAllModules",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/TablemangeController/show_module/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 👉 4. Fetch All Companies
export const fetchCompanyData = createAsyncThunk(
  "project/fetchCompanyData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/CustomerSupport/wsetwertgvsdxsadf4556666`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const addComplain = createAsyncThunk(
  "project/addComplain",
  async ({ values }, { rejectWithValue }) => {

    try {
      const response = await axios.post(
        `${BaseUrl}/ConplainController/dfshfgjhfgjfghjfsgh`,
        {
          PresentStatus: values.PresentStatus,
          Requirement: values.Requirement,
          Solution: values.Solution,
          Benefit: values.Benefit,
          Project: values.Project,
          Module: values.Module,
          Photos: values.photos,
          CompanyName: values.CompanyName,
          InPutId: PersonData.data._id,
          Type: values.Type,
          Requirement_Type: values.Requirement_Type,
        }
      );

      if (response.data.status === "Dev Conplain added") {

        return response.data;
      } else {
        return rejectWithValue("Failed to add complaint");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const clientMainPost = createAsyncThunk(
  "project/clientMainPost",
  async ({ values, supportId }, { rejectWithValue }) => {


    try {
      const response = await axios.post(
        `${BaseUrl}/ConplainController/dfshfgjhfgjfghjftghjfghjgh`,
        {
          PresentStatus: values.PresentStatus,
          Requirement: values.Requirement,
          Solution: values.Solution,
          Benefit: values.Benefit,
          Project: values.Project,
          Module: values.Module,
          Photos: values.photos,
          ContactPerName: values.ContactPerName,
          ContactPer: values.ContactPer,
          CompanyName: values.CompanyName,
          InPutId: supportId,
          Type: values.Type,
          Requirement_Type: values.Requirement_Type,
          Partition: "Customer Side"
        }
      );

      if (response.data.status === "Conplain add") {

        return response.data.status;
      } else {
        return rejectWithValue("Failed to add complaint");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addDynamicCustomer = createAsyncThunk(
  "project/addDynamicCustomer",
  async (data, { rejectWithValue }) => {

    try {
      const response = await axios.post(
        `${BaseUrl}/CustomerSupport/DynamicCustomer_Comn/${data.Comn}`,
        {
          Name: data.Name,
          ContactNo: data.Number,
        }
      );
      return response.data; // Adjust this based on what you want in state
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// ✅ Initial State (Flat structure with unique loading/error for each)
const initialState = {
  allProjects: [],
  allTypes: [],
  allModules: [],
  allCompanies: [],
  addComplainStatus: null,
  addclientMainPost: null,
  addDynamicCustomerStatus: null,

  loadingProjects: false,
  errorProjects: null,

  loadingTypes: false,
  errorTypes: null,

  loadingModules: false,
  errorModules: null,

  loadingCompanies: false,
  errorCompanies: null,
  // sdfsds
  loadingAddComplain: false,
  errorAddComplain: null,


  loadingclientMainPost: false,
  errorclientMainPost: null,



  loadingDynamicCustomer: false,
  errorDynamicCustomer: null,
};

const RequestServicestSlice = createSlice({
  name: "requestservice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // 🚀 All Projects
      .addCase(fetchAllProjects.pending, (state) => {
        state.loadingProjects = true;
        state.errorProjects = null;
      })
      .addCase(fetchAllProjects.fulfilled, (state, action) => {
        state.loadingProjects = false;
        state.allProjects = action.payload;
      })
      .addCase(fetchAllProjects.rejected, (state, action) => {
        state.loadingProjects = false;
        state.errorProjects = action.payload;
      })

      // 📁 All Types
      .addCase(fetchAllTypes.pending, (state) => {
        state.loadingTypes = true;
        state.errorTypes = null;
      })
      .addCase(fetchAllTypes.fulfilled, (state, action) => {
        state.loadingTypes = false;
        state.allTypes = action.payload;
      })
      .addCase(fetchAllTypes.rejected, (state, action) => {
        state.loadingTypes = false;
        state.errorTypes = action.payload;
      })

      // 🧩 All Modules
      .addCase(fetchAllModules.pending, (state) => {
        state.loadingModules = true;
        state.errorModules = null;
      })
      .addCase(fetchAllModules.fulfilled, (state, action) => {
        state.loadingModules = false;
        state.allModules = action.payload;
      })
      .addCase(fetchAllModules.rejected, (state, action) => {
        state.loadingModules = false;
        state.errorModules = action.payload;
      })

      // 🏢 Company Data
      .addCase(fetchCompanyData.pending, (state) => {
        state.loadingCompanies = true;
        state.errorCompanies = null;
      })
      .addCase(fetchCompanyData.fulfilled, (state, action) => {
        state.loadingCompanies = false;
        state.allCompanies = action.payload;
      })
      .addCase(fetchCompanyData.rejected, (state, action) => {
        state.loadingCompanies = false;
        state.errorCompanies = action.payload;
      })

      // dfsdfgdg

      .addCase(addComplain.pending, (state) => {
        state.loadingAddComplain = true;
        state.errorAddComplain = null;
      })
      .addCase(addComplain.fulfilled, (state, action) => {
        state.loadingAddComplain = false;
        state.addComplainStatus = action.payload;
      })
      .addCase(addComplain.rejected, (state, action) => {
        state.loadingAddComplain = false;
        state.errorAddComplain = action.payload;
      })


      .addCase(clientMainPost.pending, (state) => {
        state.loadingclientMainPost = true;
        state.errorclientMainPost = null;
      })
      .addCase(clientMainPost.fulfilled, (state, action) => {
        state.loadingclientMainPost = false;
        state.addclientMainPost = action.payload;
      })
      .addCase(clientMainPost.rejected, (state, action) => {
        state.loadingclientMainPost = false;
        state.errorclientMainPost = action.payload;
      })



      // 🆕 Add Dynamic Customer
      .addCase(addDynamicCustomer.pending, (state) => {
        state.loadingDynamicCustomer = true;
        state.errorDynamicCustomer = null;
      })
      .addCase(addDynamicCustomer.fulfilled, (state, action) => {
        state.loadingDynamicCustomer = false;
        state.addDynamicCustomerStatus = action.payload; // Store response
      })
      .addCase(addDynamicCustomer.rejected, (state, action) => {
        state.loadingDynamicCustomer = false;
        state.errorDynamicCustomer = action.payload;
      })

  },
});

export default RequestServicestSlice.reducer;
